import { Observable } from 'rxjs';
import { FieldDefGroup } from '.';

export const OperatorDisplayMap = Object.freeze({
  eq: 'Equals',
  gt: 'Greater Than',
  gte: 'Greater Than or Equals',
  lt: 'Less Than',
  lte: 'Less Than or Equals',
  contains: 'Contains',
  like: 'Like',
  in: 'In',
  not: 'Not',
  is: 'Is',
});

export type Operator = keyof typeof OperatorDisplayMap;

export type FieldType =
  | 'number'
  | 'money'
  | 'text'
  | 'percent'
  | 'select'
  | 'checkbox'
  | 'date'
  | 'datetime'
  | 'decimal'
  | 'textarea'
  | 'record'
  | 'url'
  | 'typeahead'
  | 'tags'
  | 'year'
  | 'id';

export interface FilterListItemModel {
  name: string;
  label: string;
  type: FieldType;
  meta: {
    filtering: { operators: Operator[]; functions?: string[]; exclude_in_nested_filter?: boolean };
    options: string[] | { label: string; value: string }[];
    multi_select?: boolean;
    record_type?: string;
    option_name?: string;
    scale?: number;
    group?: FieldDefGroup;
    sorting?: string;
  };
}

/**
 * Stand-in for "whoever is signed in" in the value of a user field's filter. It is what gets saved (e.g. in a saved
 * view); it is replaced with the real user right before the query is sent.
 */
export const CURRENT_USER_FILTER_TOKEN = '$CURRENT_USER';
export const CURRENT_USER_FILTER_LABEL = 'Current User';

export interface FilterListItemValueModel {
  fieldName: string;
  operator: Operator;
  value: any;
}

export interface FilterListItemChangeArgs extends FilterListItemValueModel {
  index: number;
}

export interface LookupContract {
  lookFor(model: LookupFilter): Observable<LookupResult[]>;
  createAndLink(model: LookupQuickAdd): Observable<any>;
  doesSupportCreate(relatedTo: string, recordType: string): boolean;
}

export interface LookupFilter {
  query: string;
  relatedTo: string;
  field?: string;
}

export interface LookupResult {
  id: number | string;
  label: string;
  company?: any;
}

export interface LookupQuickAdd {
  name: string;
  fieldName: string;
  recordType: string;
  relatedTo: string;
  linkedTo: { id: number; [key: string]: any };
  multiSelect: boolean;
}
